export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SECONDS = 10;
export const RESULTS_PER_PAGE = 10;
export const API_KEY = "b3198fb2-e422-4dca-aa42-379d1607d9a5";
export const MODAL_CLOSE_SECONDS = 1.5;

// API KEY FOR DEVELOPMENT
// "e034d060-15ef-49db-aa69-079bfe47bb7d"
// "1be8afcd-ad47-4a3f-b74c-f1415ade9721"

// API KEY FOR DEPLOYMENT
// "c21ab67d-6209-4e20-959d-984c046d0e41"
